/**
 * D577: the name of a KYC document type. The types are DATA of the market's catalog (a country adds its own, each with the
 * labels the operator wrote), so the name comes from the entry when the screen has it; a type it does not know (a retired type, a
 * catalog the screen has not loaded) reads as the catalogued "document of an unregistered type" (D588), never as the stored code.
 */
type Types = readonly { readonly code: string; readonly labels: Readonly<Record<string, string>> }[] | undefined;

export function documentTypeName(
  types: Types,
  code: string,
  lang: string,
  v: (id: string, code: string | null | undefined) => string,
): string {
  const found = types?.find((x) => x.code === code);
  const named = found?.labels[lang] ?? found?.labels['en'] ?? (found === undefined ? undefined : Object.values(found.labels)[0]);
  return named !== undefined && named.trim() !== '' ? named : unregisteredDocumentType(v);
}

/** D588: the words for a document type the market catalog the screen holds does not list. */
export function unregisteredDocumentType(v: (id: string, code: string | null | undefined) => string): string {
  return v('kyc.document_type_fallback', 'NOT_IN_CATALOG');
}
